<div class="tile" (click)="onClick.next(product)">
  <a class="tile__content" [routerLink]="getProductUrl(product) | localize">
    <div class="image-container" 
         [ngClass]="{'hover-price': (canDisplayHoverPrices$ | async) && product?.unitPrice}">
      <img 
        class="product__image" 
        [src]="product?.image + PresentationConstants.imagePrefix.desktop.catalog" 
        alt="product image" 
      />
      <span class="price-on-hover" *ngIf="(canDisplayHoverPrices$ | async) && product?.unitPrice">
        {{ product!.unitPrice | localizedCurrency }}
        <br>
        {{'product_tile.unit_price' | translate}}
      </span>
    </div>
    <p class="product__price" *ngIf="canDisplayPrices$ | async">
      {{ product?.price | localizedCurrency }}
    </p>
    <p class="product__code">
      {{ "product_tile.reference_abbreviation" | translate }} <span class="product__code--selectable">{{ product?.code }}</span>
    </p>
    <p class="product__name">{{ product?.name }}</p>
    <p class="product__units">
      {{
        "product_tile.box_of_n_units"
          | translate: { quantity: product?.units ?? 0 }
      }}
    </p>
    <p class="product__unit-price" *ngIf="canDisplayPrices$ | async">
      {{
        ("product_tile.the_unit_price_is" | translate) + ' ' + (product?.unitPrice ?? 0 | localizedCurrency)
      }}
    </p>
  </a>
  <ep-fav-button
    class="floating-button"
    *ngIf="hasAddToListButton && !hasDeleteButton && (isLoggedIn$ | async) && !(isGuest$ | async)"
    [product]="product"
    [isFavorite]="product?.isFavorite"
  ></ep-fav-button>
  <svg-icon
    class="floating-button"
    *ngIf="hasDeleteButton"
    src="./assets/icons/close.svg"
    (click)="onClickDeleteButton.emit(product); $event.stopPropagation()"
  ></svg-icon>

  <app-product-labels
    class="product__labels"
    *ngIf="product"
    [isNew]="product.isNew"
    [isTopProducts]="product.isTopProducts"
    [isPromotion]="product.isPromotion"
    [withoutStock]="product.hasStock == null ? false : !product.hasStock"
  ></app-product-labels>
</div>
